.linkContainIcon {
  display: inline-flex;
  align-items: center;
  margin-left: 16px;
}

.descriptionAlignEnd  {
  margin-bottom: var(--space-2);

  :global(.ant-alert-content .ant-alert-description) {
    text-align: end;
  }
}